// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1g961mok>div{border-radius:var(--ds-radius-large,8px)}\n._1qo3155r>div{border:var(--_gf55z1)}", ""]);
// Exports
module.exports = exports;
